import { useMemo } from 'react';
import { ANCHOR_ATTRIBUTE, type OnboardingAnchor } from './anchors';

export type AnchorProps = Record<typeof ANCHOR_ATTRIBUTE, OnboardingAnchor>;

/**
 * Помечает элемент якорем онбординга: `{...useOnboardingAnchor('mailbox.addButton')}`.
 *
 * Оформлено хуком, а не константой, по двум причинам: ключ проверяется типом (опечатка
 * или удалённый якорь не соберутся), а объект пропсов стабилен между рендерами и не
 * заставляет React перевешивать атрибут. Способ поиска элемента при этом остаётся
 * деталью реализации — движок ищет его по атрибуту, а не по CSS-классам.
 */
export function useOnboardingAnchor(anchor: OnboardingAnchor): AnchorProps {
  return useMemo(() => ({ [ANCHOR_ATTRIBUTE]: anchor }), [anchor]);
}
